// @flow
import {
    BULB_SAVED,
    CHANGE_BRIGHTNESS,
    CHANGE_COLOR_MODE,
    COLOR_CHANGED,
    TOGGLE_DONE,
    TOGGLE_LIGHTBULB
} from './constants';

import { getProductIndexById } from '../selectors';
import { undoable } from '../utils';

export default {
    [CHANGE_BRIGHTNESS]: undoable((state, { payload: { productId, brightness } }) => {
        try {
            const index = getProductIndexById(state, productId);

            return {
                ...state,
                productItems: state.productItems
                    .setIn([index, 'isSaving'], true)
                    .setIn([index, 'state', 'value'], brightness)
                    .setIn([index, 'state', 'brightness'], brightness)
                    .setIn([index, 'state', 'status'], 'ON')
            };
        } catch (e) {
            return state;
        }
    }),

    [TOGGLE_DONE]: (state, { payload }) => {
        // $FlowFixMe
        const index = getProductIndexById(state, payload.productId);
        return {
            ...state,
            // $FlowFixMe
            productItems: state.productItems.setIn([index, 'isToggling'], false)
        };
    },

    [BULB_SAVED]: (state, { payload }) => {
        const index = getProductIndexById(state, payload.productId);
        return {
            ...state,
            productItems: state.productItems.setIn([index, 'isSaving'], false)
        };
    },

    [TOGGLE_LIGHTBULB]: undoable((state, { payload }) => {
        const index = getProductIndexById(state, payload.productId);

        return {
            ...state,
            productItems: state.productItems
                .updateIn([index, 'state', 'status'], item => (item === 'ON' ? 'OFF' : 'ON'))
                .setIn([index, 'isToggling'], true)
        };
    }),
    [COLOR_CHANGED]: undoable((state, { payload }) => {
        const { h, s } = payload.hsv;
        const index = getProductIndexById(state, payload.productId);

        return payload.isCustomRange
            ? {
                  ...state,
                  productItems: state.productItems
                      .setIn([index, 'state', 'colourTemperature'], payload.valueInRange)
                      .setIn([index, 'isSaving'], true)
              }
            : {
                  ...state,
                  productItems: state.productItems.withMutations(items =>
                      items
                          .setIn([index, 'isSaving'], true)
                          .setIn([index, 'state', 'hue'], h)
                          .setIn([index, 'state', 'saturation'], s)
                  )
              };
    }),
    [CHANGE_COLOR_MODE]: undoable((state, { payload: { productId, mode } }) => {
        const index = getProductIndexById(state, productId);

        return {
            ...state,
            productItems: state.productItems.setIn([index, 'state', 'colourMode'], mode)
        };
    })
};



// WEBPACK FOOTER //
// ./src/core/state/products/bulbs/index.js